document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        const cepInput = document.querySelector("#ShippingZip_");
        const calcularFreteBtn = document.querySelector("[data-action='estimate-shipping']");

        if (cepInput && calcularFreteBtn) {
            // Armazenar CEP no LocalStorage
            calcularFreteBtn.addEventListener("click", function () {
                let cep = cepInput.value.trim().replace("-", ""); // Remove traço do CEP
                if (cep.length === 8) {
                    localStorage.setItem("user_cep", cep);
                    console.log("✅ CEP salvo no LocalStorage:", cep);
                } else {
                    console.warn("❌ CEP inválido:", cep);
                }
            });

            // Permitir cálculo ao pressionar Enter
            cepInput.addEventListener("keypress", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault(); // Evita que o formulário seja enviado
                    calcularFreteBtn.click(); // Simula o clique no botão
                }
            });
        } else {
            console.warn("⚠️ Campos de CEP ou botão de frete não encontrados.");
        }

        // Recuperar CEP salvo automaticamente
        const savedCep = localStorage.getItem("user_cep");
        if (cepInput && savedCep) {
            cepInput.value = savedCep;
            console.log("🔄 CEP recuperado automaticamente:", savedCep);

            // Simula o clique para calcular automaticamente o frete
            if (calcularFreteBtn) {
                calcularFreteBtn.click();
            }
        }
    }, 1000);
});
